module.exports = {
      id: "search-usage",
      viewBox: "0 0 20 20.051",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#search",
      toString: function () {
        return this.url;
      }
    }